// extracted by mini-css-extract-plugin
module.exports = {"tabBodyItemActive":"tabBodyItemActive-2-fk2TaV","tabBodyItem":"tabBodyItem-2X8IRw01"};